/* ============================================================
   Labella.hu – Kedvencek (wishlist)
   Betöltés: snippets/theme-variables.liquid
   Stílus: assets/labella-wishlist.css

   Mit csinál:
   - minden termékkártyára kitesz egy szív gombot,
   - a fejlécbe, a kosár ikon mellé, egy szív ikont számlálóval,
   - a mentett termékeket egy beúszó panelben mutatja meg,
   - a listát el lehet küldeni e-mailben (a látogató saját
     levelezőjével), és a linkről bármelyik eszközön visszatölthető.

   A hírlevél-feliratkozás egyelőre NINCS a panelben: a Shopify
   láthatatlan CAPTCHA-t tesz a vásárlói űrlapokra, és azt csak az
   általa kiszolgált űrlap kapja meg. Szkriptből küldve „Missing
   CAPTCHA token" a válasz. Akkor kerülhet be, ha a bolt saját
   hírlevél-űrlapjáról biztosan tudjuk, hogy működik.

   Hol tárolja: a látogató böngészőjében (localStorage), tehát nem
   kell hozzá bejelentkezés. Eszközönként külön lista van, és a
   böngészőadatok törlésekor elveszik – ez a megoldás ára.

   A téma HTML-jéhez nem nyúlunk, ezért a téma frissítése sem
   írja felül. A panel a téma saját .side-drawer stílusait
   használja, hogy ugyanúgy nézzen ki, mint a kosár.
   ============================================================ */
(function () {
  'use strict';

  var KEY = 'labella_kedvencek_v1';
  var DRAWER_ID = 'labella-wishlist-drawer';
  var URL_PARAM = 'kedvencek';
  var MAX_RESTORE = 60;

  /* Termékadatok a panel megnyitásakor (változatok, ár, készlet).
     Csak a memóriában él, nem terheljük vele a localStorage-ot. */
  var PROD = {};

  var HEART =
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
    '<path d="M12 20.4 4.2 12.6a4.8 4.8 0 0 1 6.8-6.8l1 1 1-1a4.8 4.8 0 0 1 6.8 6.8Z"/></svg>';
  var CLOSE_X =
    '<svg viewBox="0 0 11.8 11.8" fill="currentColor" aria-hidden="true" focusable="false">' +
    '<path d="M11.5,10.6L6.7,5.9l4.7-4.7c0.2-0.2,0.2-0.6,0-0.8c-0.2-0.2-0.6-0.2-0.8,0L5.9,5.1L1.2,0.3c-0.2-0.2-0.6-0.2-0.8,0' +
    'c-0.2,0.2-0.2,0.6,0,0.8l4.7,4.7l-4.7,4.7c-0.2,0.2-0.2,0.6,0,0.8c0.2,0.2,0.6,0.2,0.8,0l4.7-4.7l4.7,4.7c0.2,0.2,0.6,0.2,0.8,0' +
    'C11.7,11.2,11.7,10.8,11.5,10.6z"/></svg>';

  /* ---------- tároló ---------- */
  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY));
      return Array.isArray(v) ? v : [];
    } catch (e) {
      return [];
    }
  }
  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {}
  }
  function has(handle) {
    var l = read();
    for (var i = 0; i < l.length; i++) if (l[i].h === handle) return true;
    return false;
  }
  function add(item) {
    var l = read();
    for (var i = 0; i < l.length; i++) if (l[i].h === item.h) return;
    l.unshift(item);
    write(l);
  }
  function remove(handle) {
    write(
      read().filter(function (x) {
        return x.h !== handle;
      })
    );
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function money(cents) {
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        var f =
          typeof moneyFormat !== 'undefined' && moneyFormat
            ? moneyFormat
            : Shopify.money_format;
        return Shopify.formatMoney(cents, f);
      }
    } catch (e) {}
    return Math.round(cents / 100).toLocaleString('hu-HU') + ' Ft';
  }

  function sized(url) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=400';
  }

  /* ---------- adatok kiolvasása egy termékkártyáról ---------- */
  function cardData(box) {
    var card = box.closest('.product-card-item') || box.parentElement;
    if (!card) return null;
    var a = box.querySelector('a.product-img') || card.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var href = a.getAttribute('href') || '';
    var m = href.match(/\/products\/([^/?#]+)/);
    if (!m) return null;

    var titleEl = card.querySelector('.product-title');
    var priceEl = card.querySelector('.product-price .actual-price') || card.querySelector('.product-price');
    var img = box.querySelector('.product-img .media img');
    var src = '';
    if (img) src = img.getAttribute('data-src') || img.getAttribute('src') || '';
    src = src.replace('{width}', '400');

    return {
      h: m[1],
      t: titleEl ? titleEl.textContent.replace(/\s+/g, ' ').trim() : m[1],
      u: href.split('?')[0],
      p: priceEl ? priceEl.textContent.replace(/\s+/g, ' ').trim() : '',
      i: src
    };
  }

  /* ---------- szív gomb a kártyákon ---------- */
  function addHeart(box) {
    if (!box || box.querySelector('.labella-heart')) return;
    var data = cardData(box);
    if (!data) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'labella-heart' + (has(data.h) ? ' is-on' : '');
    btn.setAttribute('data-handle', data.h);
    btn.setAttribute('aria-pressed', has(data.h) ? 'true' : 'false');
    btn.setAttribute('aria-label', 'Kedvencekhez');
    btn.setAttribute('title', 'Kedvencekhez');
    btn.innerHTML = HEART;
    box.appendChild(btn);
  }

  function scanCards(root) {
    var nodes = (root || document).querySelectorAll('.product-card-img');
    for (var i = 0; i < nodes.length; i++) addHeart(nodes[i]);
  }

  function syncHearts() {
    var list = read();
    var on = {};
    for (var i = 0; i < list.length; i++) on[list[i].h] = true;
    var btns = document.querySelectorAll('.labella-heart');
    for (var j = 0; j < btns.length; j++) {
      var h = btns[j].getAttribute('data-handle');
      var isOn = !!on[h];
      btns[j].classList.toggle('is-on', isOn);
      btns[j].setAttribute('aria-pressed', isOn ? 'true' : 'false');
    }
  }

  /* ---------- fejléc ikon ---------- */
  function addHeaderIcon() {
    if (document.querySelector('.labella-wish-link')) return;
    var cart = document.querySelector('.header-icons-list a.header-icons-link.cart');
    if (!cart) return;
    var cartLi = cart.closest('li');
    if (!cartLi || !cartLi.parentElement) return;

    var li = document.createElement('li');
    li.className = 'header-icons labella-wish-li';
    li.innerHTML =
      '<a class="header-icons-link labella-wish-link" href="#' + DRAWER_ID + '" ' +
      'aria-label="Kedvencek">' + HEART +
      '<span class="cart-count labella-wish-count hidden"></span></a>';
    cartLi.parentElement.insertBefore(li, cartLi);
  }

  function updateCount() {
    var n = read().length;
    var badges = document.querySelectorAll('.labella-wish-count');
    for (var i = 0; i < badges.length; i++) {
      badges[i].textContent = n ? String(n) : '';
      badges[i].classList.toggle('hidden', n === 0);
    }
    var links = document.querySelectorAll('.labella-wish-link');
    for (var j = 0; j < links.length; j++) links[j].classList.toggle('has-items', n > 0);
  }

  /* ---------- beúszó panel ---------- */
  function buildDrawer() {
    var d = document.getElementById(DRAWER_ID);
    if (d) return d;
    d = document.createElement('div');
    d.id = DRAWER_ID;
    d.className = 'side-drawer labella-wish-drawer scheme-secondary';
    d.setAttribute('role', 'dialog');
    d.setAttribute('aria-label', 'Kedvencek');
    d.innerHTML =
      '<div class="close-fullwidth cursor-pointer" data-wish-close></div>' +
      '<div class="side-drawer-panel"><div class="side-drawer-inner">' +
      '<button class="drawer-close" type="button" aria-label="Bezárás" data-wish-close>' + CLOSE_X + '</button>' +
      '<div class="labella-wish-inner">' +
      '<div class="labella-wish-head"><h2>Kedvencek</h2><span class="labella-wish-sub"></span></div>' +
      '<ul class="labella-wish-body"></ul>' +
      '<div class="labella-wish-foot">' +
      '<p class="labella-wish-foot-title">Mentsd el a listát</p>' +
      '<p class="labella-wish-foot-note">A lista ebben a böngészőben marad meg. ' +
      'Küldd el magadnak, és bármelyik gépen vagy telefonon vissza tudod tölteni.</p>' +
      '<div class="labella-wish-field">' +
      '<input type="email" class="labella-wish-email" placeholder="E-mail címed" autocomplete="email">' +
      '<button type="button" class="labella-wish-send">Elküldöm</button>' +
      '</div>' +
      '<button type="button" class="labella-wish-copy">Inkább csak a linket másolom</button>' +
      '<p class="labella-wish-msg" role="status"></p>' +
      '</div>' +
      '</div></div></div>';
    document.body.appendChild(d);
    return d;
  }

  /* A sorhoz tartozó változatválasztó és Kosárba gomb.
     Csak akkor jelenik meg, ha a termékadatok már megérkeztek. */
  function controlsFor(it) {
    var pd = PROD[it.h];
    if (!pd) return '';
    var vs = pd.variants || [];
    var firstAvailable = null;
    for (var i = 0; i < vs.length; i++) {
      if (vs[i].available) {
        firstAvailable = vs[i];
        break;
      }
    }
    if (!firstAvailable) {
      return '<span class="labella-wish-sold">Jelenleg nem rendelhető</span>';
    }

    var sel = '';
    if (vs.length > 1) {
      sel = '<select class="labella-wish-variant" aria-label="Változat">';
      for (var j = 0; j < vs.length; j++) {
        var v = vs[j];
        sel +=
          '<option value="' + v.id + '"' +
          (v.available ? '' : ' disabled') +
          (v.id === firstAvailable.id ? ' selected' : '') +
          '>' + esc(v.title) + ' – ' + esc(v.price) +
          (v.available ? '' : ' (elfogyott)') + '</option>';
      }
      sel += '</select>';
    }

    return '<div class="labella-wish-controls">' + sel +
      '<button type="button" class="labella-wish-atc" data-atc="' + esc(it.h) + '"' +
      (vs.length > 1 ? '' : ' data-variant="' + firstAvailable.id + '"') +
      '>Kosárba</button></div>';
  }

  function refreshCartCount() {
    if (!window.fetch) return;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (c) {
        if (!c) return;
        var els = document.querySelectorAll('[data-header-cart-count]');
        for (var i = 0; i < els.length; i++) {
          els[i].textContent = c.item_count ? String(c.item_count) : '';
          els[i].classList.toggle('hidden', c.item_count === 0);
        }
      })
      .catch(function () {});
  }

  function addToCart(variantId, btn) {
    if (!window.fetch) return;
    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Egy pillanat…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then(function (r) {
        if (r.ok) return r.json();
        return r.json().then(function (j) {
          throw new Error(j.description || j.message || 'ismeretlen hiba');
        });
      })
      .then(function () {
        btn.textContent = 'Kosárban ✓';
        btn.classList.add('is-done');
        msg('Kosárba tetted. A kosár ikonra kattintva megnézheted.');
        refreshCartCount();
      })
      .catch(function (err) {
        btn.disabled = false;
        btn.textContent = original;
        msg('Nem sikerült kosárba tenni: ' + err.message, true);
      });
  }

  function renderDrawer() {
    var d = buildDrawer();
    var body = d.querySelector('.labella-wish-body');
    var sub = d.querySelector('.labella-wish-sub');
    var list = read();

    var foot = d.querySelector('.labella-wish-foot');
    if (foot) foot.style.display = list.length ? '' : 'none';

    if (!list.length) {
      sub.textContent = '';
      body.innerHTML =
        '<li class="labella-wish-empty"><strong>Még nincs mentett terméked.</strong>' +
        'A termékek sarkában lévő szívre koppintva bármit ide gyűjthetsz, ' +
        'és később egy helyen átnézheted.</li>';
      return;
    }

    sub.textContent = list.length + ' mentett termék';
    var html = '';
    for (var i = 0; i < list.length; i++) {
      var it = list[i];
      html +=
        '<li class="labella-wish-item">' +
        '<a class="labella-wish-thumb" href="' + esc(it.u) + '" tabindex="-1" aria-hidden="true">' +
        (it.i ? '<img src="' + esc(it.i) + '" alt="" loading="lazy">' : '') +
        '</a>' +
        '<div class="labella-wish-main">' +
        '<a class="labella-wish-titlelink" href="' + esc(it.u) + '">' +
        '<span class="labella-wish-title">' + esc(it.t) + '</span></a>' +
        (it.p ? '<span class="labella-wish-price">' + esc(it.p) + '</span>' : '') +
        controlsFor(it) +
        '</div>' +
        '<button class="labella-wish-remove" type="button" data-remove="' + esc(it.h) + '" ' +
        'aria-label="Eltávolítás a kedvencekből">' + CLOSE_X + '</button>' +
        '</li>';
    }
    body.innerHTML = html;
  }

  function openDrawer() {
    renderDrawer();
    var d = document.getElementById(DRAWER_ID);
    d.style.display = 'flex';
    setTimeout(function () {
      d.classList.add('sidebar-visible');
    }, 20);
    document.body.classList.add('no-scroll', 'popup-open');
    refresh();
  }

  function closeDrawer() {
    var d = document.getElementById(DRAWER_ID);
    if (!d) return;
    d.classList.remove('sidebar-visible');
    document.body.classList.remove('no-scroll', 'popup-open');
    setTimeout(function () {
      d.style.display = 'none';
    }, 500);
  }

  /* A panel újrarajzolása, ha nyitva van. Azért késleltetve, hogy a
     termékadatok beérkezése ne rajzolja újra a listát darabonként. */
  var renderTimer = null;
  function scheduleRender() {
    var d = document.getElementById(DRAWER_ID);
    if (!d || d.style.display === 'none' || !d.style.display) return;
    if (renderTimer) clearTimeout(renderTimer);
    renderTimer = setTimeout(function () {
      renderTimer = null;
      var el = document.getElementById(DRAWER_ID);
      if (el && el.style.display !== 'none') renderDrawer();
    }, 120);
  }

  /* ---------- friss ár / elérhetőség a panel megnyitásakor ---------- */
  var refreshing = false;
  function refresh() {
    if (refreshing) return;
    var list = read();
    if (!list.length || !window.fetch) return;
    refreshing = true;

    var queue = list.slice();
    var results = {};
    var gone = {};
    var active = 0;
    var done = 0;

    function finish() {
      refreshing = false;
      var cur = read();
      var next = [];
      for (var i = 0; i < cur.length; i++) {
        var it = cur[i];
        if (gone[it.h]) continue;
        var r = results[it.h];
        if (r) {
          it.t = r.t;
          it.p = r.p;
          it.i = r.i || it.i;
          it.out = r.out;
        }
        next.push(it);
      }
      write(next);
      updateCount();
      scheduleRender();
    }

    function step() {
      while (active < 4 && queue.length) {
        var item = queue.shift();
        active++;
        (function (it) {
          fetch('/products/' + encodeURIComponent(it.h) + '.js', { credentials: 'same-origin' })
            .then(function (r) {
              if (r.status === 404) {
                gone[it.h] = true;
                return null;
              }
              return r.ok ? r.json() : null;
            })
            .then(function (p) {
              if (p) {
                results[it.h] = {
                  t: p.title,
                  p: money(p.price),
                  i: sized(p.featured_image),
                  out: !p.available
                };
                var vs = [];
                for (var k = 0; k < p.variants.length && k < 60; k++) {
                  var v = p.variants[k];
                  vs.push({
                    id: v.id,
                    title: v.title,
                    price: money(v.price),
                    available: !!v.available
                  });
                }
                PROD[it.h] = { variants: vs, available: !!p.available };
              }
            })
            .catch(function () {})
            .then(function () {
              active--;
              done++;
              scheduleRender();
              if (!queue.length && active === 0) finish();
              else step();
            });
        })(item);
      }
    }
    step();
  }

  /* ---------- megosztható link, e-mail ---------- */
  function handles() {
    return read().map(function (x) {
      return x.h;
    });
  }

  function shareLink() {
    var hs = handles().slice(0, MAX_RESTORE);
    return location.origin + '/?' + URL_PARAM + '=' + encodeURIComponent(hs.join(','));
  }

  function msg(text, bad) {
    var el = document.querySelector('.labella-wish-msg');
    if (!el) return;
    el.textContent = text || '';
    el.classList.toggle('is-bad', !!bad);
  }

  function validEmail(v) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
  }

  function sendMail(email) {
    var list = read().slice(0, 20);
    var lines = '';
    for (var i = 0; i < list.length; i++) {
      lines += '- ' + list[i].t + (list[i].p ? ' – ' + list[i].p : '') + '\n  ' +
        location.origin + list[i].u + '\n';
    }
    var body =
      'Ezeket a bútorokat tettem félre a Labella webáruházban:\n\n' + lines +
      '\nA teljes listát egy kattintással visszatöltöd bármelyik gépen vagy telefonon:\n' +
      shareLink() + '\n';
    window.location.href =
      'mailto:' + encodeURIComponent(email) +
      '?subject=' + encodeURIComponent('Labella – a kedvenc bútoraim') +
      '&body=' + encodeURIComponent(body);
  }

  function copyFallback(link) {
    try {
      var ta = document.createElement('textarea');
      ta.value = link;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.top = '0';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      ta.setSelectionRange(0, link.length);
      var ok = document.execCommand('copy');
      document.body.removeChild(ta);
      if (ok) {
        msg('A link a vágólapon van – beillesztheted, ahova szeretnéd.');
        return true;
      }
    } catch (e) {}
    return false;
  }

  function copyLink() {
    var link = shareLink();
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(link).then(
        function () {
          msg('A link a vágólapon van – beillesztheted, ahova szeretnéd.');
        },
        function () {
          if (!copyFallback(link)) msg('Nem sikerült a másolás. A link: ' + link, true);
        }
      );
      return;
    }
    if (!copyFallback(link)) msg('Nem sikerült a másolás. A link: ' + link, true);
  }

  /* Linkről érkezés: a címben kapott termékek hozzáadása a listához. */
  function restoreFromUrl() {
    var raw = null;
    try {
      raw = new URLSearchParams(location.search).get(URL_PARAM);
    } catch (e) {
      var m = location.search.match(/[?&]kedvencek=([^&]*)/);
      raw = m ? decodeURIComponent(m[1]) : null;
    }
    if (!raw) return false;

    var incoming = raw.split(',').slice(0, MAX_RESTORE);
    var list = read();
    var have = {};
    for (var i = 0; i < list.length; i++) have[list[i].h] = true;
    var added = 0;
    for (var j = incoming.length - 1; j >= 0; j--) {
      var h = incoming[j].trim();
      if (!h || have[h] || !/^[a-z0-9\-_%]+$/i.test(h)) continue;
      list.unshift({ h: h, t: h, u: '/products/' + h, p: '', i: '' });
      have[h] = true;
      added++;
    }
    if (added) write(list);
    try {
      var u = new URL(location.href);
      u.searchParams.delete(URL_PARAM);
      history.replaceState({}, '', u.toString());
    } catch (e2) {}
    return true;
  }

  /* ---------- események ---------- */
  document.addEventListener(
    'click',
    function (e) {
      var t = e.target;
      if (!t || t.nodeType !== 1 || !t.closest) return;

      var heart = t.closest('.labella-heart');
      if (heart) {
        e.preventDefault();
        e.stopPropagation();
        var box = heart.closest('.product-card-img');
        var data = box ? cardData(box) : null;
        var handle = heart.getAttribute('data-handle');
        if (has(handle)) {
          remove(handle);
        } else if (data) {
          add(data);
          heart.classList.add('just-added');
          setTimeout(function () {
            heart.classList.remove('just-added');
          }, 350);
        }
        syncHearts();
        updateCount();
        var d = document.getElementById(DRAWER_ID);
        if (d && d.classList.contains('sidebar-visible')) renderDrawer();
        return;
      }

      var open = t.closest('.labella-wish-link');
      if (open) {
        e.preventDefault();
        e.stopPropagation();
        openDrawer();
        return;
      }

      if (t.closest('[data-wish-close]')) {
        e.preventDefault();
        e.stopPropagation();
        closeDrawer();
        return;
      }

      if (t.closest('.labella-wish-send')) {
        e.preventDefault();
        e.stopPropagation();
        var field = document.querySelector('.labella-wish-email');
        var mail = field ? field.value.trim() : '';
        if (!validEmail(mail)) {
          msg('Adj meg egy érvényes e-mail címet.', true);
          if (field) field.focus();
          return;
        }
        msg('Elkészítettük az üzenetet a leveleződben – már csak el kell küldened.');
        sendMail(mail);
        return;
      }

      var atc = t.closest('.labella-wish-atc');
      if (atc) {
        e.preventDefault();
        e.stopPropagation();
        var vid = atc.getAttribute('data-variant');
        if (!vid) {
          var row = atc.closest('.labella-wish-item');
          var sel = row ? row.querySelector('.labella-wish-variant') : null;
          vid = sel ? sel.value : null;
        }
        if (vid) addToCart(vid, atc);
        return;
      }

      if (t.closest('.labella-wish-copy')) {
        e.preventDefault();
        e.stopPropagation();
        copyLink();
        return;
      }

      var rm = t.closest('[data-remove]');
      if (rm) {
        e.preventDefault();
        e.stopPropagation();
        remove(rm.getAttribute('data-remove'));
        renderDrawer();
        syncHearts();
        updateCount();
      }
    },
    true
  );

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var d = document.getElementById(DRAWER_ID);
    if (d && d.classList.contains('sidebar-visible')) closeDrawer();
  });

  /* Másik fülön történt változás átvétele */
  window.addEventListener('storage', function (e) {
    if (e.key && e.key !== KEY) return;
    syncHearts();
    updateCount();
    var d = document.getElementById(DRAWER_ID);
    if (d && d.classList.contains('sidebar-visible')) renderDrawer();
  });

  function start() {
    addHeaderIcon();
    var restored = restoreFromUrl();
    scanCards();
    updateCount();
    if (restored) {
      syncHearts();
      openDrawer();
    }
    if (!window.MutationObserver || !document.body) return;
    var timer = null;
    new MutationObserver(function () {
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () {
        addHeaderIcon();
        scanCards();
        syncHearts();
        updateCount();
      }, 150);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();